import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/es/industrias/medical-devices/")({
  head: () => buildRouteHead("/es/industrias/medical-devices"),
  component: IndustryPage,
});

